<template>
  <div class="tbDynam">
    <el-table :data="updtList" height="340px" class="viscreantable" max-height="340px" size="small" row-class-name="trrow" :header-cell-style="tableheader" cell-class-name="column" :cell-style="{borderColor:'#35def7'}" :highlight-current-row="true">
      <el-table-column v-for="(item, index) in tableLabel" :key="index" :prop="item.prop" :width="item.width" :min-width="item.minwidth" :label="item.label" show-overflow-tooltip>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "tbDyn",
  props: {
    tableData: { type: Array },
    tableLabel: { type: Array },
  },
  data() {
    return {
      tableheader: {
        background: "#152b65",
        fontSize: "15px",
        color: "#ffffff",
        padding: "5px 0",
        "text-align": "center",
      },
      showList: [], //用于展示的数据列表
      isShowAll: true, //如果数据长度小于显示条数，就全部显示，不做滚动处理
      nextIndex: 7, //此标志用以记录，下一条滚动出来的数据所在的下标
      rows2Show: 7, //页面上显示的条数
      intervalFlag: NaN, //定时执行的记录，用以关闭执行
    };
  },
  mounted() {
    this.getTBdata(); //获取数据

    this.playDat(); //定时执行
  },
  computed: {
    updtList() {
      //显示数据更新后渲染列表
      return this.showList;
    },
  },
  methods: {
    playDat() {
      console.log(this.tableData.length);
      if (this.tableData.length > 6) {
        //定时执行
        if (this.isShowAll) {
          this.stop;
        } else {
          this.intervalFlag = setInterval(this.changeList, 2000); //每秒执行一次插入删除操作
        }
      } else {
        return false;
      }
    },
    stop() {
      if (!isNaN(this.intervalFlag)) {
        //NaN
        clearInterval(this.intervalFlag);
        this.intervalFlag = NaN;
      }
    },
    getTBdata() {
      //todo to get data from api
      if (this.tableData.length > this.rows2Show) {
        let arry = [...this.tableData];
        this.isShowAll = false;
        this.showList = arry.slice(0, this.rows2Show); //取前rows2Show个值
      } else {
        this.isShowAll = true;
        this.showList = [...this.tableData];
      }
    },

    changeList() {
      let arry1 = [...this.showList];
      if (this.tableData.length > this.nextIndex) {
        //length
        this.setList(arry1);
      } else {
        if (!this.isShowAll) {
          this.nextIndex = 0;
          this.setList(arry1);
        } else {
          //循环到了末尾
          arry1 = [...tableData];
          this.showList = arry1;
          this.stop;
        }
      }
    },
    setList(arry1) {
      if (arry1.length > 0) {
        arry1.shift(); //删除列表头条数据
        arry1.push(this.tableData[this.nextIndex]); //加入最后一条数据
        this.showList = arry1; //完成数据更新
        this.nextIndex += 1; //更新下标
        if (this.nextIndex == this.tableData.length) {
          this.nextIndex = 0;
        }
      } else {
        arry1 = [...tableData];
        this.showList = arry1.slice(0, this.rows2Show); //取前n条
        this.nextIndex = this.rows2Show;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-table__body-wrapper::-webkit-scrollbar {
  /*width: 0;宽度为0隐藏*/
  width: 0px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #eee;
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.4);
}
</style>
